export default __webpack_public_path__ + "static/media/illustration-health-3-m.1f20ec93.webp";